import React, { useState, useEffect } from "react";
import { Imbrications } from "./Imbrications";
import { Configuration } from "./Configuration";
import "../Assets/styles/newStyles/Configurations.css";
import { ShimmerThumbnail } from "react-shimmer-effects";
import axios from "../axios";
import ClipLoader from "react-spinners/ClipLoader";
import { NotificationManager } from "react-notifications";

 
const Configurations = () => {
  const [response, setResponse] = useState({});
  const [loader, setLoader] = useState(true);
  const [updatedConfigData, setUpdatedConfigData] = useState({});
  const [updatedImbricationsData, setUpdatedImbricationsData] = useState({});
  const [initialRender, setInitialRender] = useState(false);
 
 
  useEffect(() => {
    getfetchConfigurations();
  }, []);
  
  useEffect(() => {
    if (
      initialRender && (
      updatedImbricationsData.risk_s !== undefined ||
      updatedImbricationsData.covid_s !== undefined ||
      updatedImbricationsData.tb_s !== undefined ||
      updatedImbricationsData.pattern_s !== undefined)
    ) {
      adminConfigApi();
    }
  }, [ updatedImbricationsData.risk_s,
    updatedImbricationsData.covid_s,
    updatedImbricationsData.tb_s,
    updatedImbricationsData.pattern_s]);
 
  const getfetchConfigurations = async () => {
    await axios
      .get(`/configurationData/${localStorage.doctorId}`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        if (response.status === 200) {
          setResponse(response.data.configuration);
          setLoader(false);
          setInitialRender(true)
        }
      });
  };
 
 
 
  const handleConfigData = (data) => {
    setUpdatedConfigData(data);
  };
 
  const handleImbricationsData = (data) => {
    setUpdatedImbricationsData(data);
  };
 
 
  const adminConfigApi = async () => {
    setLoader(true);
 
    var jsonData = {
      risk_s: updatedImbricationsData.risk_s,
      pattern_s: updatedImbricationsData.pattern_s,
      covid_s: updatedImbricationsData.covid_s,
      tb_s: updatedImbricationsData.tb_s,
      assessment_limit: updatedConfigData.assessment_limit,
      assessment_link: updatedConfigData.assessment_link,
      exportType: updatedConfigData.exportType,
      export_data: updatedConfigData.export_data,
      feedback: updatedConfigData.feedback,
      report_level: updatedConfigData.report_level,
      symptoms: updatedConfigData.symptoms,
      vitals: updatedConfigData.vitals,
    };
    await axios
      .post(`/adminConfig`, jsonData, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((res) => {
        console.log(res);
        setResponse({...updatedConfigData, ...updatedImbricationsData})
        NotificationManager.success("Configurations Updated", "Success", 4000);
       
      })
      .catch((error) => {
        console.error(error);
       
      })
      .finally(() => {
        setLoader(false);
      });
  };
 


  return (
   
    // <div className="dashboard">
    //   <div className="dashboard__content">
        <div className="configurations-container">
          <div className="heading-button-container">
            <h1 className="usage-heading">Usage Configuration</h1>
            {/* {loader ? (
              <div
                className="configuration-button"
                style={{
                  textAlign: "center",
                  paddingTop: "8px",
                  width: "157px",
                  height: "35px",
                }}
              >
                <ClipLoader color="white" size={18} />
              </div>
            ) : (
              <button className="configuration-button" onClick={adminConfigApi}>
                Apply Configuration
              </button>
            )} */}
          </div>
          <hr className="configuration-line" />
          {loader ? (
            <div className="configuration-imbrication-container">
              <div style={{ display: "flex", gap: "7px", marginLeft:'5px' }}>
                <ShimmerThumbnail
                  height={300}
                  width={625}
                  className="m-0"
                  rounded
                />
                <ShimmerThumbnail
                  height={300}
                  width={620}
                  className="m-0"
                  rounded
                />
              </div>
              <div style={{marginLeft:'5px'}}>
              <ShimmerThumbnail
                height={300}
                width={1250}
                className="m-0"
                rounded
              />
              </div>
             
            </div>
          ) : (
            <div className="configuration-imbrication-container">
              <div className="configuration-container">
                <Configuration
                  assessment_link={response?.assessment_link}
                  export_data={response?.export_data}
                  symptoms={response?.symptoms}
                  vitals={response?.vitals}
                  feedback={response?.feedback}
                  exportType={response?.exportType}
                  report_level={response?.report_level}
                  assessment_limit={response?.assessment_limit}
                  updatedConfigFunction={handleConfigData}
                />
              </div>
              <div className="imbrications-container">
                <Imbrications
                  risk_s={response?.risk_s}
                  covid_s={response?.covid_s}
                  tb_s={response?.tb_s}
                  pattern_s={response?.pattern_s}
                  updatedImbricationsFunction={handleImbricationsData}
                 adminConfig= {adminConfigApi}
                />
              </div>
            </div>
          )}
        </div>
    //    </div>
    // </div>
  );
};
 
export default Configurations;
 